import * as React from 'react'
import ModalLayout from '../shared/ModalLayout'
import ContractHeader from './ContractHeader'
import ContractFooter from './ContractFooter'
import ContractContent from './ContractContent'

const ContractModal = ({
  close,
  driverNames,
  companyId,
  driversId,
  contractId,
  anmexId,
  annexInitialStartDate
}: {
  close: () => void
  driverNames: string[]
  driversId: number | number[]
  companyId: string
  contractId?: string
  anmexId?: string
  annexInitialStartDate?: string
}) => {
  return (
    <ModalLayout>
      <div className="tw-flex tw-h-full tw-max-h-[800px] tw-w-[90vw] tw-max-w-[1200px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <ContractHeader driverNames={driverNames} close={close} />
        <ContractContent companyId={companyId} />
        <ContractFooter
          annexInitialStartDate={annexInitialStartDate}
          anmexId={anmexId}
          close={close}
          companyId={companyId}
          driverNames={driverNames}
          driversId={driversId}
          contractId={contractId}
        />
      </div>
    </ModalLayout>
  )
}

export default ContractModal
